import './portfolio.scss';
import { useEffect, useState } from "react";
import { MediaService } from "../../services/mediaService";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { LoaderSpinner } from '../commons/loaderSpinner/loaderSpinner';

export function Portfolio(){

    const params = useParams();
    const lang = params.lang;
    const [categories,setCategories] = useState([]);
    const mediaService = MediaService();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                 setLoading(true)
                const res: any = await mediaService.getCategories();
                setCategories(res.data);
            } catch (error) {
                console.error("Erreur récupération catégories", error);
            }finally{
                 setLoading(false)
            }
        };
        fetchCategories();
    }, [lang]);

    return (
        <>
        <div className='portfolio-container content-container'>
            {loading ? (
            <LoaderSpinner visible={true} />
            ) : (
            <div>
                <h1>Portfolio</h1>
                <div className="categories-image-container grid col-3">
                    {
                        categories.map(((category:any)=>(
                            <div key={category.id}>
                                <div className="img-container">
                                    <Link to={ `/${lang}/portfolio/category/${category.slug}`}>
                                        <img src={category.image} alt={category.name}/>
                                    </Link>
                                </div>
                                <p>{category.name}</p>
                            </div>
                        )))
                    }
                </div>
            </div>)}
        </div>
        </>)
}

